import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";
import blindDateLogo from "../assets/blind-date-with-text-logo.webp";

export const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header
      className="
        fixed top-0 left-0 w-full z-50 
        bg-background/80 backdrop-blur-lg    
        border-b-[3px] border-secondary 
        shadow-sm
      "
    >
      <nav className="w-full px-6 sm:px-10 h-[88px] flex items-center justify-between">
        {/* --- LOGO (left) --- */}
        <Link
          to="/"
          onClick={() => setMenuOpen(false)}
          className="flex items-center"
        >
          <motion.img
            src={blindDateLogo}
            alt="The Blind Date Logo"
            className="h-20 w-auto object-contain object-center p-2"
            whileHover={{ scale: 1.03 }}
            transition={{ duration: 0.2 }}
          />
        </Link>

        {/* --- DESKTOP NAVIGATION (right) --- */}
        <ul className="hidden sm:flex items-center gap-10 text-[15px] font-medium">
          <NavItem to="/" label="Home" />
          <NavItem to="/how-it-works" label="How It Works" />
          <NavItem to="/about" label="About" />
          <NavItem to="/contact" label="Contact" />
        </ul>

        {/* --- MOBILE MENU BUTTON (hamburger) --- */}
        <button
          className="sm:hidden text-primary text-3xl focus:outline-none"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          {menuOpen ? "✕" : "☰"}
        </button>
      </nav>

      {/* --- Mobile Dropdown --- */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.25 }}
            className="sm:hidden bg-background/95 backdrop-blur-lg border-b border-secondary shadow-md"
          >
            <ul className="flex flex-col py-4 px-6 space-y-4 text-lg font-medium">
              <MobileNavItem
                to="/"
                label="Home"
                onClick={() => setMenuOpen(false)}
              />
              <MobileNavItem
                to="/how-it-works"
                label="How It Works"
                onClick={() => setMenuOpen(false)}
              />
              <MobileNavItem
                to="/about"
                label="About"
                onClick={() => setMenuOpen(false)}
              />
              <MobileNavItem
                to="/contact"
                label="Contact"
                onClick={() => setMenuOpen(false)}
              />
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

/* === DESKTOP NAV ITEM === */
const NavItem = ({ to, label }: { to: string; label: string }) => (
  <NavLink
    to={to}
    className={({ isActive }) =>
      `relative pb-1 transition text-[17px] ${
        isActive
          ? "text-primary" /* red for active */
          : "text-foreground hover:text-primary" /* navy → hover red */
      }`
    }
  >
    {({ isActive }) => (
      <>
        {label}
        {isActive && (
          <motion.div
            layoutId="nav-underline"
            className="absolute left-0 -bottom-[3px] w-full h-[2px] bg-primary rounded-full"
          />
        )}
      </>
    )}
  </NavLink>
);

/* === MOBILE NAV ITEM === */
const MobileNavItem = ({ to, label, onClick }: any) => (
  <NavLink
    to={to}
    onClick={onClick}
    className={({ isActive }) =>
      `block ${
        isActive ? "text-primary" : "text-foreground"
      } hover:text-primary transition`
    }
  >
    {label}
  </NavLink>
);
